import { DocumentTypesUppercaseEnum } from 'common/src/modules/modals/modals-common/link-document-modal/enums/ducument-types.enum';

export const DOCUMENT_CREATED_TOAST_KEYS: { [documentType: string]: string } = {
  [DocumentTypesUppercaseEnum.OFR]: 'OFFER.HAS_BEEN_CREATED_SUCCESS',
  [DocumentTypesUppercaseEnum.SO]: 'SO.HAS_BEEN_CREATED_SUCCESS',
  [DocumentTypesUppercaseEnum.PO]: 'SUCCESS_CREATED.PO',
  [DocumentTypesUppercaseEnum.SBC]: 'SUBSCRIPTION.HAS_BEEN_CREATED_SUCCESS',
  [DocumentTypesUppercaseEnum.DN]: 'WAREHOUSE.DELIVERY_NOTE.DN_CREATE_SUCCESS',
  [DocumentTypesUppercaseEnum.OIN]: 'OIN.HAS_BEEN_CREATED_SUCCESS',
  [DocumentTypesUppercaseEnum.IIN]: 'IIN.CREATED_SUCCESS',
  [DocumentTypesUppercaseEnum.CRN]: 'CREDIT_NOTE.HAS_BEEN_CREATED_SUCCESS',
};

export function getDocumentCreatedToastKey(documentType: DocumentTypesUppercaseEnum): string {
  return DOCUMENT_CREATED_TOAST_KEYS[documentType];
}
